//import { logout } from '../actions/security';
import * as historyProvider from "./historyProvider";
//import { INDEX_ROUTE } from "../const/routesLocations";

export function handleApiError(store, error) {
    if (error.response) {
        handleErrorFromApi(store, error.response);
    }
}

function handleErrorFromApi(store, errorResponse) {
    if (errorResponse.status === 401) {
        let userId = store.getState().security.userId;
        // if (isNumber(userId)) //Do przeprowadzenia logout
        //     store.dispatch(logout({ userId: userId }));
    }
    if (errorResponse.status === 403) {
        historyProvider.push("/");
    }
}
